<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <img class="icon_img" src="@/assets/images/popup_icon_gift.png" alt="icon">
            <div class="text_2">
              <!-- 부안 잼버리222 -->
                <div class="gift_receive" v-if="popupGift.mingle_gift_order === '6' && popupGift.mingle_no === '1'">
                  <b>잼버리 코스</b> 완성!!<br/>
                  <span>축하합니다!!</span>
                </div>
                <!-- 코리아둘레길 인증 팝업 -->
                <div class="gift_receive" v-else-if="popupGift.mingle_gift_add_point && (popupGift.mingle_no === '10' || popupGift.mingle_no === '16')">
                  <b>{{popupGift.mingle_gift_title.slice(0, 4)}} 완보를<br>축하드립니다.</b><br/><br/>
                  {{popupGift.mingle_gift_title.slice(0, 4)}}을 완보하신 분께는 한국관광공사에서 완보증과<br/>기념품을 드립니다.<br/><br/>
                  - {{popupGift.mingle_gift_title.slice(0, 4)}} 완보증 발급 문의 -<br/>
                  한국의길과문화 02-6013-6610~3
                </div>
                <div class="gift_receive" v-else-if="popupGift.mingle_gift_add_point && popupGift.mingle_no === '14'">
                  <b>봉사점수 신청하기</b><br/>
                </div>
                <!-- 태백 거주자 필터 -->
                <div class="gift_receive" v-else-if="popupGift.mingle_no === '15' && memberInfo.address.indexOf('태백시') > -1">
                  <b>신청 불가</b><br/><br/>
                  <span>모바일 상품권은 태백시 관내<br>거주민에게는 제공되지 않습니다.</span>
                </div>
                <!-- 원주 거주자 필터 -->
                <div class="gift_receive" v-else-if="popupGift.mingle_no === '20' && memberInfo.address.indexOf('원주시') > -1">
                  <b>신청 불가</b><br/><br/>
                  <span>모바일 상품권은 원주시 관내<br>거주민에게는 제공되지 않습니다.</span>
                </div>
                <div class="gift_receive" v-else>
                  <b>{{popupGift.mingle_count}}{{unit}}</b> 달성!!<br/>
                  <span>축하합니다!!</span>
                </div>
                <span v-if="popupGift.mingle_no !== '25'">
                    <img :src="imgIcon()" alt="gs25"><br/>
                    {{popupGift.mingle_gift_title}}
                </span>
                <div class="agree_pop" v-if="agreeCheck">
                  <div class="notice">Notice</div>
                  <!-- <div class="agree_title">
                    개인정보 제3자 제공 동의가 필요합니다.
                  </div> -->
                  <div class="agree_desc">
                    • 제공받는 기관<br>
                    <span>{{ stampTitle }}</span><br/>
                    • 수집/이용 목적<br>
                    <span>선물 발급 통계정보 작성</span><br/>
                    • 제공하는 개인 정보 항목<br>
                    <span>연락처, 주소, 이름, 성별, 생년월일</span><br/>
                    • 보유기간 : <span>1년</span>
                  </div>
                  <div class="agree_info">
                    <div class="tit">주소</div>
                    <span>{{memberInfo.address || '정보 없음'}}</span>
                    <div class="tit">휴대폰</div>
                    <span>{{memberInfo.mobile || '정보 없음'}}</span>
                  </div>
                </div>
                <div class="gift_msg" v-if="agreeCheck">
                  위 개인정보 제 3자 제공 동의를 거부하실 수 있으며, 거부 시 이벤트 참여가 제한될 수 있습니다.
                </div>
                <div class="check" v-if="agreeCheck">
                  <input type="checkbox" id="personal"  name="personal" v-model="personal"> <label for="personal">개인정보 제 3자 제공 동의합니다.</label>
                </div>
            </div>
            <button
              class="type1"
              :class="(popupGift.mingle_no === '25' || (popupGift.mingle_no === '20' && memberInfo.address.indexOf('원주시') > -1) || surveyBool) ? 'w100' : ''"
              @click="closeBtn"
            >
              닫기
            </button>
            <button
              class="type2"
              @click="receiveGift"
              v-if="popupGift.mingle_no !== '25' && (popupGift.mingle_no !== '20' || memberInfo.address.indexOf('원주시') === -1) && !surveyBool"
            >
              {{receiveBtn(popupGift)}}
            </button>
        </div>
        <div class="loading_back" v-if="submitCheck">
          <img src="@/assets/images/ajax-loader.gif" alt="loader">
        </div>
        <PopupGiftPop v-if="popupNoti.open" />
        <PopupGiftApi v-if="popCustomApi" :info="popupGift" />
        <!-- 커스텀 팝업 221128 teddy -->
        <CustomPopup v-if="customPopup" status="gift" />
    </div>
</template>
<script>
import { mapState } from 'vuex'
import * as appEvent from '@/assets/js/app_event.js'
import PopupGiftPop from '@/components/popup/PopupGiftPop.vue'
import PopupGiftApi from '@/components/popup/PopupGiftApi.vue'
import CustomPopup from '@/components/event/popup/CustomPopup.vue'
export default {
  name: 'PopupGiftReceive',
  components: {
    PopupGiftPop,
    PopupGiftApi,
    CustomPopup
  },
  data () {
    return {
      personal: false,
      agreeCheck: true,
      unit: '',
      surveyBool: false,
      stampTitle: ''
    }
  },
  computed: {
    ...mapState(['popupGift', 'mingleCode', 'memberInfo', 'stampCodeInfo', 'popupNoti', 'submitCheck', 'popCustomApi', 'imjingangSurveySuccess', 'customPopup'])
  },
  methods: {
    closeBtn () {
      // window.history.back()
      this.$store.dispatch('openPopupGift', {})
    },
    receiveGift () {
      if (!this.memberInfo.address || !this.memberInfo.mobile) {
        this.$store.dispatch('openNotiPopup', {
          tit1: '선물을 받기 위해<br/>아래의 정보가 필요합니다.',
          tit2: '주소, 휴대폰 번호'
        })
      } else {
        if (!this.personal) {
          this.$store.dispatch('openNotiPopup', {
            tit1: '선물을 받기 위해<br/>개인정보 제3자 제공 동의가<br/>필요합니다.',
            tit2: ''
          })
        } else {
          if (this.popupGift.mingle_gift_add_point) {
            let url = ''
            if (this.popupGift.mingle_no === '18' || this.popupGift.mingle_no === '22') {
              if (this.$store.state.token !== '' && this.$store.state.token !== null) {
                // this.$store.dispatch('raffleRequest', this.popupGift)
                if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
                  url = `https://m.tranggle.com/mingle/coursebook/auth/2?token=${this.$store.state.token}&mingleCode=${this.$store.state.mingleCode}`
                } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('iPad') > -1 || navigator.userAgent.toLowerCase().indexOf('iPod') > -1) {
                  url = `https://m.tranggle.com/mingle/coursebook/auth/2?token=${this.$store.state.token}_${this.$store.state.mingleCode}`
                }
                this.closeBtn()
              }
            } else if (this.popupGift.mingle_no === '43') {
              if (this.$store.state.token !== '' && this.$store.state.token !== null) {
                if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
                  url = `https://m.tranggle.com/mingle/coursebook/auth/1?token=${this.$store.state.token}&mingleCode=${this.$store.state.mingleCode}`
                } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('iPad') > -1 || navigator.userAgent.toLowerCase().indexOf('iPod') > -1) {
                  url = `https://m.tranggle.com/mingle/coursebook/auth/1?token=${this.$store.state.token}_${this.$store.state.mingleCode}`
                }
              }
            }
            // 코리아 둘레길 완주증 신청
            if (this.popupGift.mingle_no === '16') {
              this.$store.dispatch('koreaCompleteRequest', this.popupGift)
            }
            // 건강도시 스탬프투어
            if (this.popupGift.mingle_no === '65') {
              this.$store.state.customPopup = true
              // this.$store.dispatch('raffleRequest', this.popupGift)
            }
            if (url) {
              setTimeout(() => {
                appEvent.externalLinks(url)
              }, 10)
            }
            // 선물 팝업 api 연동
            if (this.popupGift.gift_popup) {
              this.$store.state.popCustomApi = true
              this.$store.dispatch('raffleRequest', this.popupGift)
            }
          } else {
            if (!this.submitCheck) {
              // 머니콘 신청
              this.$store.state.submitCheck = true
              //  신청 로그 체크
              this.$store.dispatch('ApplyCheckMoneycon', { pGift: this.popupGift, mInfo: this.memberInfo })
            }
          }
        }
      }
    },
    imgIcon () {
      return `https://tg-s3.tranggle.com/mingle/image/mingle/${this.popupGift.mingle_gift_image}`
    },
    agreeBtn () {
      if (this.memberInfo.address && this.memberInfo.mobile) {
        // alert('개인정보 제3자 제공에 동의하셨습니다.')
        this.$cookie.set('agree_security', 'Y', 9999)
        // this.popup = false
      }
    },
    agreeOn () {
      let className = ''
      if (this.memberInfo.address && this.memberInfo.mobile) {
        className = 'on'
      }
      return className
    },
    setStamp () {
      this.stampCodeInfo.map((data) => {
        if (data.code === this.mingleCode && data.info === 'point') {
          this.unit = 'P'
        } else if (data.code === this.mingleCode && data.info === 'number') {
          this.unit = '개'
        }
      })
    },
    receiveBtn (data) {
      let val = ''
      if (data.mingle_gift_add_point) {
        val = '신청하기'
      } else {
        val = '모바일 상품권 받기'
      }
      return val
    }
  },
  watch: {
    personal () {
      if (this.personal) {
        this.agreeBtn()
      } else {
        this.$cookie.set('agree_security', 'N', 9999)
      }
    },
    imjingangSurveySuccess () {
      // 파주 임진강 스탬프 전용 설문
      this.$store.dispatch('raffleRequest', this.popupGift)
    }
  },
  mounted () {
    this.setStamp()
    if (this.$cookie.get('agree_security') === 'Y') {
      this.personal = true
      this.agreeCheck = false
    }
    if (this.mingleCode === 'zedR3VKvwxcbfLBwwJtDAg==') {
      this.personal = false
      this.agreeCheck = true
    }
    // 스탬프투어명 가져오기
    this.stampTitle = this.stampCodeInfo.filter((val) => val.code === this.mingleCode)[0] && this.stampCodeInfo.filter((val) => val.code === this.mingleCode)[0].name
  },
  destroyed () {
    // this.$router.go()
    if (this.$route.fullPath === '/allgift') {
      this.$store.dispatch('loadAllGiftData')
    } else {
      this.$store.dispatch('loadGiftData')
    }
  }
}
</script>
<style scoped>
  .colorfont {
    color: #3bb9fa;
  }
  .w100 {
    width: 100%!important;
    border:0!important;
  }
  .loading_back {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(15, 14, 14, 0.3);
    z-index: 999999;
  }
  .loading_back img {
    width:40px;
    position:absolute;
    top:315px;
    left:50%;
    margin-left: -20px;
  }
</style>
